import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY } from "@/data/company";
import CallbackForm from "@/components/site/CallbackForm";
import { useSeo } from "@/lib/useSeo";

export default function Contact() {
  useSeo("Contact & devis gratuit", "Contactez SMT Provence pour un devis gratuit : maçonnerie, béton, murs, clôtures et aménagements extérieurs à Saint-Victoret et dans le 13.");
  const info = [
    { icon: Phone, label: "Téléphone", value: COMPANY.phone, href: `tel:${COMPANY.phoneHref}` },
    { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
    { icon: MapPin, label: "Adresse", value: COMPANY.address },
    { icon: Clock, label: "Horaires", value: "Lun–Ven : 8h–18h" },
  ];
  return (
    <div>
      <section className="pt-32 pb-16 bg-ink">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="overline text-primary">Parlons de votre projet</span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white">Contact & devis</h1>
          <p className="mt-4 text-white/70 max-w-2xl">Devis personnalisé, gratuit et sans engagement. Nous vous répondons rapidement.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {info.map((it) => (
              <div key={it.label} className="bg-card border border-border rounded-2xl p-6">
                <div className="h-10 w-10 rounded-lg bg-accent text-primary flex items-center justify-center mb-3"><it.icon size={20} /></div>
                <p className="text-xs font-semibold text-ink/50 uppercase tracking-wide">{it.label}</p>
                {it.href ? <a href={it.href} className="font-heading font-bold text-ink hover:text-primary">{it.value}</a> : <p className="font-heading font-bold text-ink">{it.value}</p>}
              </div>
            ))}
          </div>
          <div className="mt-6 rounded-2xl overflow-hidden border border-border h-72">
            <iframe title="Carte SMT Provence" width="100%" height="100%" style={{ border: 0 }} loading="lazy"
              src="https://www.google.com/maps?q=665+Avenue+du+Raumartin,+13730+Saint-Victoret&output=embed" />
          </div>
        </div>
        <div className="bg-card border border-border rounded-2xl p-6 sm:p-8">
          <h2 className="font-heading text-2xl font-black text-ink mb-1">Demande de rappel</h2>
          <p className="text-sm text-ink/60 mb-5">Remplissez le formulaire, nous vous recontactons.</p>
          <CallbackForm source="contact" />
        </div>
      </section>
    </div>
  );
}
